import axios from "axios";
import { endpoints } from "./endPoints";

export const apiService = () => {
 const baseUrl = process.env.REACT_APP_API_URL;

 return {
  email: {
   newsLetters: (body) => {
    const url = `${baseUrl}/${endpoints.email.newsletters}`;
    return axios.post(url, body);
   },
  },
  plans: {
   getPlans: () => {
    const url = `${baseUrl}/${endpoints.plans}`;
    return axios.get(url);
   },
  },
  paymentClient: {
   generateAccesToken: () => {
    const url = `${baseUrl}/${endpoints.paymentNiubiz.generateToken}`;

    console.log("url", url);
    return axios.get(url);
   },
   sessionToken: (data) => {
    const url = `${baseUrl}/${endpoints.paymentNiubiz.createSessionToken}`;

    return axios.post(url, data);
   },
  },
  user: {
   getEmail: (email) => {
    const url = `${baseUrl}/${endpoints.user.getEmail}?email=${email}`;
    return axios.get(url);
   },
  },
 };
};
